var BlockCompiler = require("../../compiler/compiler.js");
var CBlockType = require("../../compiler/types.js");
var CoreFunctions = require("../../compiler/corefunc.js");

BlockCompiler.defineBlock("operator_sign", {
  type: CBlockType.OUTPUT,
  func: function (utils) {
    var NUM = utils.getInput("NUM", "0");
    var NUM_NUMBER = CoreFunctions.castToNumber(NUM, false);

    return `Math.sign(${NUM_NUMBER})`;
  },
});
